// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-formitem-label {
  color: inherit;
  margin-bottom: 8px;
}
.bolt-formitem-label--required {
  color: rgba(218, 10, 0, 1);
  color: var(--status-error-text,rgba(218, 10, 0, 1));
}
.bolt-formitem-label--required-field-text {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.bolt-formitem-message {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
  margin-top: 8px;
}

.bolt-formitem-message-error {
  color: rgba(218, 10, 0, 1);
  color: var(--status-error-text,rgba(218, 10, 0, 1));
}

.bolt-formitem-message-warning {
  color: rgba(184, 94, 6, 1);
  color: var(--status-warning-text,rgba(184, 94, 6, 1));
}

/*# sourceMappingURL=FormItem.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/FormItem/FormItem.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/FormItem/FormItem.css"],"names":[],"mappings":"AACA;EAGI,cAAA;EACA,kBCoTQ;ACtTZ;AFGI;EACI,0BCoNY;ECrNlB,mDAAmD;AFGjD;AEDJ;EFGQ,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EEDN,gBAAgB;AAClB;;AAEA;EFII,yBCoSQ;ECtSV,qDAAqD;EACrD,eAAe;AFIjB;;AEDA;EACE,0BAA0B;EFI5B,mDAAA;AEFA;;AAEA;EACE,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA,uCAAuC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
